import { useState } from 'react';
import { Box } from '@chakra-ui/react';
import useVideoAspect from '@/hooks/content/useVideoAspect';
import LandscapeReel from '@/modules/content/loop/variants/LandscapeReel';
import PortraitReel from '@/modules/content/loop/variants/PortraitReel';
import { TLoopReelProps, TLoopVariantProps } from '@/modules/content/loop/model/types';

// Picks the reel layout from the video's real shape rather than assuming one. Once a Mux
// player reports its true dimensions, that overrides the probed guess.
//
// Deliberately no opacity treatment while orientation resolves: reduced opacity means
// "not the thing you are pointing at" in the loop, so reusing it as a loading hint would
// collide with the hover model and compound with the chrome's own resting dim.
const ReelVariant = (props: TLoopVariantProps) => {
  const detected = useVideoAspect(props.content);
  const [measured, setMeasured] = useState<number | null>(null);

  const ratio = measured ?? detected.ratio;
  const reelProps: TLoopReelProps = { ...props, ratio, onRatioDetected: setMeasured };

  return (
    <Box width="100%">
      {ratio >= 1 ? <LandscapeReel {...reelProps} /> : <PortraitReel {...reelProps} />}
    </Box>
  );
};

export default ReelVariant;
